import React, { ReactNode } from "react";

export const Content = ({
  title,
  subtitle,
  id,
}: {
  title: string;
  subtitle: string;
  id: string;
}) => {

  return (
    <div className={"section"}>
      <div className="sectiondiv" id={id}>
        <div className="content">
          <h1>{title}</h1>
			<iframe className="pinterestembed" src="https://widget.tagembed.com/6855?view"></iframe>
			<script src="//widget.tagembed.com/embed.min.js" type="text/javascript"></script>
        </div>
      </div>
    </div>
  );
};
